import { Typography } from "antd";
const { Text } = Typography;

const TextWithBR = ({ line1, line2, color }) => {
    return (
        <>
            <div>
                {line1 || line2 ? (
                    <>
                        <Text>{line1 ? line1 : "-"}</Text>
                        <br />
                        {color != "" ? (
                            <>
                                <Text style={{ color: color }}>{line2 ? line2 : "-"}</Text>
                            </>
                        ) : (
                            <>
                                <Text>{line2 ? line2 : "-"}</Text>
                            </>
                        )}
                    </>
                ) : (
                    !line1 && !line2 && "-"
                )}
            </div>
        </>
    );
};

export default TextWithBR;
